import { postRequest } from 'utils/api'
import { sortByTimestamp } from 'utils/collectionHelper'
import { AI_STT_URL, PUBLIC_AI_STT_URL } from 'services/constants'
import moment from 'moment'

const voiceRecordingHelper = (
  currentUserMessageIndex,
  transcriptMessages,
  setMessages,
  isPublicRolePlay
) => {
  let recordedChunks = []
  let mediaRecorder = null
  const AUDIO_CHUNK_SIZE = 20

  const cleanMediaListeners = () => {
    if (mediaRecorder) {
      mediaRecorder?.removeEventListener('dataavailable', audioListener)
      mediaRecorder = null
    }
  }

  const audioListener = event => {
    if (event.data.size > 0) {
      recordedChunks.push(event.data)
      if (recordedChunks.length === AUDIO_CHUNK_SIZE) {
        sendAudioInBatch(recordedChunks.splice(0, AUDIO_CHUNK_SIZE))
      }
    }
  }

  const startRecording = async () => {
    try {
      recordedChunks = [] // Reset previous chunks
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        sampleRate: 48000
      })
      mediaRecorder = new MediaRecorder(stream)
      mediaRecorder.addEventListener('dataavailable', audioListener)
      mediaRecorder.start(1000)
    } catch (err) {
      console.error(err)
    }
  }

  const stopRecording = () => {
    if (!mediaRecorder) return
    mediaRecorder?.stop()
    mediaRecorder?.stream.getTracks().forEach(track => track.stop())

    // Wait for MediaRecorder to finish processing
    mediaRecorder.onstop = async () => {
      sendAudioInBatch(recordedChunks)
      cleanMediaListeners()
    }
  }

  const sendAudioInBatch = async batch => {
    if (batch.length === 0) return
    let audioBlob = new Blob(batch, { type: 'audio/webm' })

    // Convert Blob to Base64
    const audioBase64 = await convertBlobToBase64(audioBlob)

    const newWord = {
      text: '',
      timestamp: moment().format()
    }

    const res = await postRequest(
      isPublicRolePlay ? PUBLIC_AI_STT_URL : AI_STT_URL,
      {
        audio: audioBase64,
        encoding: 'WEBM_OPUS'
      }
    )
    if (res.status === 200) {
      if (res.data.data) {
        newWord.text = res.data.data
        transcriptMessages[currentUserMessageIndex].words.push(newWord)

        // Sort the words and update the content
        transcriptMessages[currentUserMessageIndex].words = sortByTimestamp(
          transcriptMessages[currentUserMessageIndex].words
        )
        transcriptMessages[currentUserMessageIndex].content =
          transcriptMessages[currentUserMessageIndex].words
            .map(w => w.text)
            .join(' ')

        setMessages(transcriptMessages)
      }
    }
  }

  const convertBlobToBase64 = blob => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(blob)
      reader.onloadend = () => {
        const base64String = reader.result.split(',')[1] // Remove the "data:audio/webm;base64," prefix
        resolve(base64String)
      }
      reader.onerror = reject
    })
  }

  return { startRecording, stopRecording }
}

export default voiceRecordingHelper
